"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommitteeRepresentative = void 0;
const PreludeCard_1 = require("../../prelude/PreludeCard");
const CardName_1 = require("../../../CardName");
const CardRenderer_1 = require("../../render/CardRenderer");
const SendDelegateToArea_1 = require("../../../deferredActions/SendDelegateToArea");
const Vitor_1 = require("../../prelude/Vitor");
const DeferredAction_1 = require("../../../deferredActions/DeferredAction");
class CommitteeRepresentative extends PreludeCard_1.PreludeCard {
    constructor() {
        super({
            name: CardName_1.CardName.COMMITTEE_REPRESENTATIVE,
            metadata: {
                cardNumber: 'Y35',
                renderData: CardRenderer_1.CardRenderer.builder((b) => {
                    b.tr(2).delegates(1).br.br;
                    b.award().br;
                }),
                description: 'Raise your TR 2 steps. Place a delegate, and fund an award for free.',
            },
        });
    }
    play(player) {
        player.increaseTerraformRatingSteps(2);
        player.game.defer(new SendDelegateToArea_1.SendDelegateToArea(player, 'Select where to send delegate', { count: 1, source: 'reserve' }));
        player.game.defer(new DeferredAction_1.DeferredAction(player, () => Vitor_1.Vitor.fundAwardForFree(player)));
        return undefined;
    }
    ;
}
exports.CommitteeRepresentative = CommitteeRepresentative;
//# sourceMappingURL=CommitteeRepresentative.js.map